export const locale = {
    lang: 'ar',
    data: {
        BOARD_WHERE_TO_PLACE: 'ما هي اللوحة التي تريد استيراد البطاقات منها؟',
        BOARD_ACTIVITY: 'اللوحة',
        CANCEL: 'إلغاء',
        SAVE: 'حِفْظْ',
    }
};
